import { Link, useParams } from 'react-router-dom'
import { useApiQuery } from 'grabbitbot-legacy-ui'
import { tradingClient } from '../../api'
import { StrategyTable } from './StrategyTable'
import { failureText } from '../../api/errorMessages'

/** Margin is not rewritten (owner 2026-09-26); legacy's strategy pages were
 * spot-only too (the wrapper rendered nothing for another trading type). */
export function MarginNotSupported({ title }: { title: string }) {
  return (
    <div className="portal-card">
      <h1>{title}</h1>
      <p className="portal-notice portal-notice--warning">Margin trading is not supported.</p>
    </div>
  )
}

/** Equivalent of legacy `V3StrategyListSpotComponent` (route
 * `strategy/:tradingType`): `GET /v3/spot/config/strategy` — the strategies
 * the user owns or is subscribed to. */
export function StrategyListPage() {
  const { tradingType = 'spot' } = useParams<{ tradingType: string }>()
  const { data, loading, error } = useApiQuery(() => tradingClient.searchStrategies(), [])
  if (tradingType !== 'spot') return <MarginNotSupported title="Strategy" />
  return (
    <div>
      <div className="portal-page-title">
        <h1>Strategy</h1>
        <Link to="/strategy/spot/search">Strategy Marketplace</Link>
      </div>
      <div className="portal-card">
        {loading && <p>Loading…</p>}
        {error && <p role="alert">{failureText(error, 'Could not load your strategies')}</p>}
        {data && <StrategyTable strategies={Array.isArray(data) ? data : []} />}
      </div>
    </div>
  )
}
